module.exports = __webpack_public_path__ + "static/media/front.674fadef.jpg";